import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { LATEST_STEP_RUNS_KEY } from '@/utils/queryKeys.ts';
import { AxiosError } from 'axios';
import { get_run_latest_step_runs_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import useRunId from '@/hooks/useRunId.ts';
import { StepRunScopeQuery, StepsRuns } from '@/types/stepExecutions.ts';
import { getStepRunScopeQueryParams } from '@/utils/stepRunScope.ts';

const useLatestStepRuns = (
  scope: StepRunScopeQuery | undefined,
  enabled: boolean,
): UseQueryResult<StepsRuns, AxiosError> => {
  const apiClient = useApiClient();
  const runId = useRunId();
  const automationId = useAutomationId();

  return useQuery({
    queryKey: LATEST_STEP_RUNS_KEY(automationId, runId, scope),
    queryFn: async () => {
      const response = await apiClient.get(get_run_latest_step_runs_url(runId), {
        params: getStepRunScopeQueryParams(scope),
      });
      return response.data;
    },
    enabled: !!runId && enabled,
  });
};

export default useLatestStepRuns;
